import React from "react"
import { useDispatch, useSelector } from "react-redux"

import {
    StoreType,
    setCcReviewReviewSelected,
} from "client/store"
import { CheckButton } from "client/components"

interface SelectAllProps {
    title?: string
}

const InputSelectAll = ({
    title = "",
}: SelectAllProps) => {
    const itemIds = useSelector((state: StoreType) => state.ccReviewReview.itemIds)
    const selected = useSelector((state: StoreType) => state.ccReviewReview.selected)
    const dispatch = useDispatch()

    const selectedAll = selected.length === itemIds.length && itemIds.length > 0

    const selectAll = () => {
        if (selectedAll) {
            dispatch(setCcReviewReviewSelected([]))
        } else {
            dispatch(setCcReviewReviewSelected(itemIds))
        }
    }

    return (
        <CheckButton
            title={title}
            checked={selectedAll}
            padding={false}
            margin={false}
            onChange={selectAll}
        />
    )
}
export default InputSelectAll
